export const _companySizes = [
  '1-10 Employees',
  '10-25 Employees',
  '25-50 Employees',
  '50-100 Employees',
  '>100 Employees',
];
